module.exports = __webpack_public_path__ + "img/logo.3798ea7b.png";